var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagType,_vm._g(_vm._b({tag:"component",class:[
    `cv-switcher-item-link`,
    `${_vm.carbonPrefix}--switcher__item-link`,
    { [`${_vm.carbonPrefix}--switcher__item-link--selected`]: _vm.selected },
  ]},'component',_vm.linkProps,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }